<template>
  <div :class="[{'menu-modal': isSlideToRight}, partnerClass]" >
    <transition :name="direction">
      <div v-if="isExploring && isMoreDropdown" class="categories" :class="{'slide': isSlideToRight}">
        <ul v-if="moreLinks.length > 0" class="nav-links-container">
          <li v-for="navLink in moreLinks" :key="navLink.id"
              class="category-item nav-link is-unselectable cursor-pointer"
              @click.prevent="selectPage(navLink)">
            <router-link class="category"
               @click.native.prevent="selectPage(subItem)"
              to="">
              {{ navBarString(navLink.displayTextKey) }}
            </router-link>
          </li>
        </ul>
        <ul v-if="navLinks.length > 0" class="nav-links-container">
          <li v-for="navLink in navLinks" :key="navLink.id">
            <div v-if="!isTopic && viewportWidth < navLink.maxViewWidth"
                 class="category-item nav-link is-unselectable cursor-pointer">
              <div v-if="!navLink.subItems" @click.prevent="selectPage(navLink)">
                <router-link v-if="navLink.redirectRoute"
                             class="category"
                             :to="navLink.redirectRoute">
                  {{ navBarString(navLink.displayTextKey)}}
                </router-link>
                <a v-if="navLink.externalUrl"
                   class="category"
                   :href="navLink.externalUrl"
                   target="_blank">
                  {{ navBarString(navLink.displayTextKey)}}
                </a>
              </div>
              <div v-if="navLink.subItems"
                   @click="toggleNavSubItemExplore(navLink)"
                   @keyup.enter="toggleNavSubItemExplore(navLink)">
                &nbsp; {{ navBarString(navLink.displayTextKey) }}
                <span :key="dropdownExploreKey">
                  <i v-if="!navLink.isExploring" class="fal fa-chevron-down" aria-hidden="true"/>
                  <i v-if="navLink.isExploring" class="fal fa-chevron-up" aria-hidden="true"/>
                </span>
              </div>
              <div v-if="navLink.isExploring">
                <span v-for="subItem in navLink.subItems" :key="subItem.id" @click.prevent="selectPage(subItem)">
                  <div v-if="subItem.isTitle" class="cursor-default sub-category">
                    <strong>{{ navBarString(subItem.displayTextKey) }}</strong>
                  </div>
                  <span v-if="!subItem.isTitle">
                    <router-link v-if="subItem.redirectRoute"
                                 class="sub-category"
                                 :to="subItem.redirectRoute">
                      {{ navBarString(subItem.displayTextKey)}}
                    </router-link>
                    <a v-if="subItem.externalUrl"
                       class="sub-category"
                       :href="subItem.externalUrl"
                       target="_blank">
                      {{ navBarString(subItem.displayTextKey)}}
                    </a>
                  </span>
                </span>
              </div>
            </div>
          </li>
        </ul>

        <!-- CATEGORIES links -->
        <section v-if="showCategoriesMore">
          <div v-for="category in categories"
               :key="category.id"
               class="category-item is-unselectable cursor-pointer"
               @click.prevent="expandCategory(category)">
            <router-link class="category" :class="{'has-text-primary': checkCategoryPreference(category)}"
               :to="!category.subCategories ? `/viewAll/?category=${category.slug}` : ''"
               :aria-label="!category.subCategories ?
                `Go to the ${category.name}` : `Show sub categories for ${category.name}`">
              {{ category.name }}
              <span v-if="isLoggedIn && checkCategoryPreference(category)" class="fas fa-star"></span>
            </router-link>
            <span v-if="category.subCategories" class="icon is-pulled-right cursor-pointer">
              <i v-if="category.id !== expandedCategoryID" class="fal fa-chevron-down"></i>
              <i v-if="category.id === expandedCategoryID" class="fal fa-chevron-up"></i>
            </span>
            <div v-if="category.id === expandedCategoryID">
              <router-link class="sub-category cursor-pointer"
                 @click.native.prevent="selectCategory(category)"
                 to="">
                {{$t('viewAll.all')}}
              </router-link>
              <router-link v-for="subCategory in subCategories"
                 :key="subCategory.id" class="sub-category cursor-pointer"
                 :class="{'has-text-primary': checkSubCategoryPreference(subCategory.id)}"
                 @click.native.prevent="selectCategory(subCategory)"
                 to=""
                 :aria-label="`Go to the ${subCategory.name} page`">
                {{ subCategory.name }}
                <span v-if="isLoggedIn && checkSubCategoryPreference(subCategory.id)" class="fas fa-star" />
              </router-link>
            </div>
          </div>
        </section>
      </div>
      <div v-if="isExploring && isSubItemDropdown" class="categories">
        <ul v-if="subItems.length > 0" class="nav-links-container">
          <li v-for="navLink in subItems" :key="navLink.id">
            <div v-if="navLink.isTitle" class="cursor-default category-item">
              <strong>{{ navBarString(navLink.displayTextKey) }}</strong>
            </div>
            <div v-if="!navLink.isTitle" class="category-item nav-link is-unselectable cursor-pointer"
                 @click.prevent="selectPage(navLink)">
              <router-link v-if="navLink.redirectRoute"
                           class="category"
                           :to="navLink.redirectRoute">
                {{ navBarString(navLink.displayTextKey) }}
              </router-link>
              <a v-if="navLink.externalUrl"
                 class="category"
                 :href="navLink.externalUrl"
                 target="_blank">
                {{ navBarString(navLink.displayTextKey)}}
              </a>
            </div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import navbarLinkMixin from './navbarLinkMixin'

import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'
import utmTracking from '@/mixins/utm-tracking'
import { getEnvName } from '@/mixins/util'

import i18n from '@/i18n'

export default {
  mixins: [navbarLinkMixin, auth, componentState, utmTracking],
  props: {
    isExploring: Boolean, // describes if the dropdown is open or not
    isMoreDropdown: Boolean, // describes if this component is being used as the more dropdown
    isTopic: Boolean,
    isSubItemDropdown: Boolean, // describes if this component is being used as a subitem dropdown
    isExhibitHallDropdown: Boolean, // describes if this component is being used as the exhibitHall dropdown
    direction: String, // 'up' or 'down'
    navLinks: Array, // Links for the more dropdown
    moreLinks: Array, // Links for the more dropdown
    subItems: Array,
    showCategoriesMore: Boolean
  },
  data: function () {
    return {
      expandedCategoryID: 0,
      userCategories: [],
      showExhibitHallSubcategories: false,
      firstOfCategory: {},
      currentPartner: getEnvName
    }
  },
  watch: {
    isExploring: function (isExploreVisible) {
      isExploreVisible ? this._callback('lockScrolling') : this._callback('unlockScrolling')
      if (this.userCategories.length === 0 && this.isLoggedIn) {
        this.fetchUserCategories()
      }
    },
    userSelectedCategories: function () {
      this.fetchUserCategories()
    }
  },
  computed: {
    categories: function () {
      return this.$store.getters.sortedProjectCategories()
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    subCategories: function () {
      return this.expandedCategoryID > 0 ? this.$store.getters.subCategoriesForID(this.expandedCategoryID) : []
    },
    projectCategoryNames: (state) => {
      return state.personalized.map((id) => state.all[id].name)
    },
    userCategoriesIDs: function () {
      return this.userCategories.map((category) => { return category.id })
    },
    isSlideToRight: function () {
      return this.direction === 'toRight'
    },
    partnerClass: function () {
      return 'exploreStories-' + process.env.APP_NAME.toLowerCase()
    },
    showFAQ: function () {
      return !this.$isAjas && !this.$isIsef && !this.$isProjectboard
    },
    userSelectedCategories: function () {
      return this.$store.getters.userCategories?.userCategories
    }
  },
  methods: {
    filterItems: function (name, links) {
      if (this.$isHeise) return links.filter(link => link.name !== name)
      return links
    },
    appBase: function () {
      return process.env.WEB_ROOT
    },
    fetchUserCategories: function () {
      this.$store.dispatch('getUserCategories', this.currentUser.userName).then((usrCategories) => {
        this.userCategories = usrCategories
      })
    },
    selectCategory: function (category) {
      const toPath = category.subCategories ? `/category/${category.slug}` : `/viewAll/?category=${category.slug}`
      if (this.$route.fullPath !== toPath) {
        if (category.subCategories) {
          this.$router.push({ name: 'projectsCategory', params: { category: category.slug } })
        } else {
          this.$router.push({ name: 'viewAll', query: { category: category.slug } })
        }
      }
      this.$emit('exitExplore')
    },
    expandCategory: function (category) {
      if (!category.subCategories) {
        this.selectCategory(category)
      } else {
        if (category.id === this.expandedCategoryID) {
          this.expandedCategoryID = 0
        } else {
          this.expandedCategoryID = category.id
        }
      }
    },
    selectPage: function (navbarItem) {
      this.followLink(navbarItem)
      this._callback('unlockScrolling')
      this.$emit('exitExplore')
      this.$emit('selectLink', navbarItem.name)
    },
    navBarString: function (displayTextKey) {
      return i18n.t(displayTextKey)
    },
    expandExhibitHallCategory: function () {
      this.showExhibitHallSubcategories = !this.showExhibitHallSubcategories
    },
    checkCategoryPreference: function (category) {
      const catOrSubCat = category.subCategories || [category.id]
      const matches = this.userCategoriesIDs.filter(cat => catOrSubCat.includes(cat))
      return matches.length > 0
    },
    checkSubCategoryPreference: function (subCategory) {
      return this.userCategoriesIDs.includes(subCategory)
    },
    hideDropdown: function () {
      this.$emit('exitExplore')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .toRight-enter-active, .toRight-leave-active,
  .down-enter-active, .down-leave-active {
    transition: all .3s ease;
  }

  .toRight-enter, .toRight-leave-to {
    transform: translateX(-15rem);
  }

  .down-enter, .down-leave-to {
    transform: translateY(-30rem);
  }

  .menu-modal {
    position: fixed;
    top: $navbar-height;
    bottom: 0;
    left: 0;
    z-index: 14;
  }

  .categories {
    position: absolute;
    z-index: 14;
    background: $white;
    min-width: 25rem;
    width: 25%;
    max-height: calc(100vh - 52px);
    padding: 0 1rem 1rem;
    &.slide {
      top: 0;
      bottom: 0;
      left: 0;
      border-top: solid 1px $grey;
    }
    overflow-y: auto;
    @include fix-ios-scrolling;

    .category-item {
      border-top: solid 1px whitesmoke;
      padding: 0.5rem 0;
      a {
        color: inherit;
      }
      &:last-of-type {
        border-bottom: solid 1px whitesmoke;
      }
      h2 {
        margin: 0.25rem 0 0.5rem;
      }
    }
    @include mobile {
        min-width: 100vw;
    }
    .category {
      font-size: 1rem;
      line-height: 1.9rem;
      margin: 0.25rem 0;
      padding: 1rem 0 1rem 0.5rem;
      &.add-indent {
        padding-left: 1.25rem;
      }
    }

    .sub-category, .sub-category-title {
      display: block;
      font-size: 0.85rem;
      line-height: 1.3rem;
      margin: 0 0 0 0.5rem;
      padding: 0.6rem 0 0.6rem 0.8rem;
    }
    .sub-category {
      &:hover {
         background: lighten($primary, 45%);
      }
    }
  }

  .capitalize {
    text-transform: capitalize;
    color: $grey-dark;
  }

  .cursor-default{
    cursor: default;
  }

</style>
